import { ConfigurationTypes } from '../const/ConfigurationTypes';
import ConfigManager from '../managers/ConfigManager';
import GameModel from "../model/GameModel";

/**
 * Provides translations for different languages.
 */
class Locale {
    public language: string;
    private sources = [];

    /**
     * Get the translation for a string with the specified identifier.
     * @param stringId
     * @returns {String}
     */
    public getString(stringId:string,patternOverrides?:string[]) {
        let translation = stringId;

        for (let i = 0; i < this.sources.length; i++) {
            let str = this.sources[i][stringId];
            if (str && str != "") {
                translation = str;
                break;
            }
        }

        const stringsOverwrites = ConfigManager.getConfig(ConfigurationTypes.LOCAL)?.overwritePatterns || [];

        if (stringsOverwrites.length > 0) {
            stringsOverwrites.forEach(({overwriteString, pattern}) => {
                let key = `{${overwriteString}}`;
                let overwriteTo = pattern();
                if (translation.indexOf(key) !== -1) {
                    translation = translation.replace(key, overwriteTo);
                }
            })
        }

        if (patternOverrides && patternOverrides.length) {
            patternOverrides.forEach((val, index) => {
                let key = "{" + index + "}";
                if(translation.indexOf(key) !== -1) {
                    translation = translation.replace(key, val);
                } else {
                  let regx =   /{{[a-zA-Z0-9_]+}}/g;
                  if(translation.match( /{{[a-zA-Z0-9_]+}}/g)){
                    translation = translation.replace(/{{[a-zA-Z0-9_]+}}/, val);
                  }
                }

            })
        }

        return translation;
    }

    public addRandomSuffix(translation) {
        let numSymsToAdd = Math.round(Math.random() * 50);

        for (let symIdx = 0; symIdx < numSymsToAdd; symIdx++) {
            translation += "z";
        }
        return translation;
    }

    public addSource(source: any) {
        if (this.sources.indexOf(source) != -1) {
            console.log(`${source} is already added to localizations array`);
        } else {
            this.sources.push(source);
        }
    }
}

export default new Locale();
